import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

const parseSearchParams = (search: string): URLSearchParams => {
  return new URLSearchParams(search);
};

const getQueryParam = (searchParams: URLSearchParams, key: string): string | undefined => {
  return searchParams.get(key) ?? undefined;
};

const useQueryParams = () => {
  const location = useLocation();

  const searchParams = useMemo(() => parseSearchParams(location.search), [location.search]);

  const getParam = (key: string): string | undefined => getQueryParam(searchParams, key);

  return {
    getParam,
    searchParams,
  };
};

const useQueryParam = (key: string): string | undefined => {
  const { getParam } = useQueryParams();
  return getParam(key) ?? undefined;
};

export { useQueryParam };
